import React from 'react';
import '../Assets/css/Seguridad.css'; // Ensure the CSS path matches your project structure

// Icons can be imported similarly if you have them in your assets folder
import absIcon from "../Assets/icon/Iconos_seguridad/Icon_ABS.svg";
import laneChangeAlertIcon from "../Assets/icon/Iconos_seguridad/Icon_CambioCarril.svg";
import adaptiveCruiseIcon from "../Assets/icon/Iconos_seguridad/Icon_CCA.svg";
import seatbeltIcon from "../Assets/icon/Iconos_seguridad/Icon_CinturonSeguridad.svg";
import injectionCutIcon from "../Assets/icon/Iconos_seguridad/Icon_CorteInyeccion.svg";
import stabilityControlIcon from "../Assets/icon/Iconos_seguridad/Icon_Estabilidad.svg";
import emergencyBrakingIcon from "../Assets/icon/Iconos_seguridad/Icon_FrenoEmergencia.svg";
import gpsIcon from "../Assets/icon/Iconos_seguridad/Icon_GPS.svg";
import maintenancePlanIcon from "../Assets/icon/Iconos_seguridad/Icon_Mantenimiento.svg";
import mobileEyeIcon from "../Assets/icon/Iconos_seguridad/Icon_MobilEye.svg";
import safetyStandardsIcon from "../Assets/icon/Iconos_seguridad/Icon_NormasSeguridad.svg";
import normIcon from "../Assets/icon/Iconos_seguridad/Icon_NormeECE.svg";
import insuranceIcon from "../Assets/icon/Iconos_seguridad/Icon_Seguros.svg";
import fatigueIcon from "../Assets/icon/Iconos_seguridad/Icon_SensorFatiga.svg";
import tractionControlIcon from "../Assets/icon/Iconos_seguridad/Icon_Traccion.svg";
import speedometerIcon from "../Assets/icon/Iconos_seguridad/Icon_Velocimetro.svg";


export const Seguridad = () => {
    const features = [
        { icon: fatigueIcon, title: "Sensor de fatiga y somnolencia", description: "Registra los movimientos de torso y ojos de un conductor, detectando cuándo este presenta síntomas de somnolencia y distracción en la cabina." },
        { icon: seatbeltIcon, title: "Cinturón de seguridad", description: "Nuestras unidades cuentan con cinturones de seguridad obligatorios para, reglamentarios y de tres puntos, garantizando la seguridad para cualquier viaje." },
        { icon: mobileEyeIcon, title: "Sensor MobileEye", description: "Sensor de visión inteligente que escanea el camino identificando objetos que puedan representar posibles amenazas." },
        { icon: gpsIcon, title: "Sistema GPS", description: "Monitoreamos constantemente el trayecto y ubicación de todos nuestros buses mediante un sistema avanzado de monitoreo GPS." },
        { icon: normIcon, title: "Norma ECE R 66.02", description: "Establece requisitos de resistencia y seguridad para techos en vehículos para prevenir colapsos en caso de volcado." },
        { icon: speedometerIcon, title: "Velocímetro visible", description: "Nuestras unidades cuentan con velocímetro visible al interior para los pasajeros, ayudando a mantener con el mismo dispositivo una parte trasera." },
        { icon: safetyStandardsIcon, title: "Normas de seguridad", description: "Buses equipados con botiquín, extintor, chaleco reflectante, conos y otros artículos de seguridad." },
        { icon: absIcon, title: "Frenos ABS", description: "Este sistema impide el bloqueo de las ruedas del vehículo en caso de una frenada de emergencia." },
        { icon: maintenancePlanIcon, title: "Plan de mantenimiento", description: "Buses siguen pauta de mantenimiento del fabricante, asegurando reparación y mantenimientos necesarios en los vehículos." },
        { icon: insuranceIcon, title: "Seguros reglamentarios", description: "Seguros nacionales obligatorios y adicionales. Responsabilidad civil, daño moral, cobertura estatal, etc., por pasajero, peatón y daños en viajes generales." },
    ];

    return (
        <div className="seguridad">
            <h1>Seguridad</h1>
            <div className="seguridad-container">
                {features.map((feature, index) => (
                    <div key={index} className="seguridad-card">
                        <img src={feature.icon} alt={feature.title}/>
                        <h2>{feature.title}</h2>
                        <p>{feature.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};


